import { render, staticRenderFns } from "./BxComplementaryMini.vue?vue&type=template&id=06d3247c&"
import script from "./BxComplementaryMini.vue?vue&type=script&lang=js&"
export * from "./BxComplementaryMini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports